import React, { useEffect, useState } from 'react'

import { API } from 'aws-amplify'
import { updateOrganization } from '../../managers/graphql/mutations'

// mui
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// redux
import { useAppDispatch, useAppSelector } from '../../hooks'
import { setLoading } from '../../managers/redux/slices/loading'
import { toast } from 'react-toastify'
import { reloadAuthAccount, setSelectedStaffProfile } from '../../managers/redux/slices/authAccount'

export default function AmbassadorSettings(props: any) {

    // redux
    const dispatch = useAppDispatch()
    const fundraising = useAppSelector(state => state.fundraising)
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

    const [singularAmbassadorOverride, setSingularAmbassadorOverride] = useState<string | null>(null)
    const [pluralAmbassadorOverride, setPluralAmbassadorOverride] = useState<string | null>(null)

    async function handleUpdateOrganizationClick() {

        dispatch(setLoading({ loading: true, message: 'Updating...' }))

        if (selectedStaffProfile && selectedStaffProfile.organizationID) {
            const { data }: any = await API.graphql({
                query: updateOrganization,
                variables: {
                    input: {
                        id: selectedStaffProfile.organizationID,
                        ambassadorTermOverrideSingular: singularAmbassadorOverride,
                        ambassadorTermOverridePlural: pluralAmbassadorOverride
                    }
                }
            })
            dispatch(reloadAuthAccount())
        } else {
            toast.error('Try again in a little bit.', { containerId: 'main' })
        }

        dispatch(setLoading({ loading: false, message: 'Updating...' }))
    }

    useEffect(() => {
        if (selectedStaffProfile) {
            if (selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular) {
                setSingularAmbassadorOverride(selectedStaffProfile.organization.ambassadorTermOverrideSingular)
            }
            if (selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverridePlural) {
                setPluralAmbassadorOverride(selectedStaffProfile.organization.ambassadorTermOverridePlural)
            }
        }
    }, [selectedStaffProfile])

    return (
        <div className="py-3 d-flex flex-column justify-content-start align-items-start w-100">
            <Typography variant="h4">{selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'} Settings</Typography>
            <Typography variant="body1" className="mb-5">Change {selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'} settings from this page</Typography>
            <div className="d-flex flex-row justify-content-center align-items-center my-3">
                <Typography variant="body1">{selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverridePlural ? selectedStaffProfile.organization.ambassadorTermOverridePlural : 'Ambassadors'} should be called (singular)</Typography>
                <TextField className="mx-3" value={singularAmbassadorOverride} onChange={(e) => setSingularAmbassadorOverride(e.target.value)} label={`${selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'} override`} placeholder='Ambassador' InputLabelProps={{ shrink: true }} />
            </div>
            <div className="d-flex flex-row justify-content-center align-items-center my-3">
                <Typography variant="body1">{selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverridePlural ? selectedStaffProfile.organization.ambassadorTermOverridePlural : 'Ambassador'} should be called (plural)</Typography>
                <TextField className="mx-3" value={pluralAmbassadorOverride} onChange={(e) => setPluralAmbassadorOverride(e.target.value)} label={`${selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'} override`} placeholder='Ambassadors' InputLabelProps={{ shrink: true }} />
            </div>
            <Button variant="contained" sx={{ width: 'auto', marginTop: '2rem' }} onClick={() => { handleUpdateOrganizationClick() }}>Save</Button>
        </div>
    )
}